import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Loadspinner from "../../common/Loadspinner";
import { APICall } from "../../helpers/API/APICalls";
import { getKnowledgeHistoryById } from "../../helpers/API/APIEndPoints";
import DynamicGrid from "../DynamicGrid/DynamicGrid";

const ViewHistory = (props) => {
  //   const { showLoader, hideLoader } = useContext(LoaderContext);
  // const [showHistoryModal, setShowHistoryModal] = useState(
  //   props.showHistoryModal
  // );
  const [loading, setLoading] = useState(false);
  const [dashboardHistoryData, setDashboardHistoryData] = useState([]);
  const dashboardHistoryOptions = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    // onSearchChange: (searchText) => {
    //   if (searchText !== null) {
    //   } else {
    //   }
    // },
    // onColumnSortChange: async (sortColumn, sortDirection) => {
    //   if (sortDirection === "asc") {

    //   }
    //   if (sortDirection === "desc") {

    //   }
    // },
    // onChangePage: async (page) => {

    // },
    textLabels: {
      body: {
        noMatch: "No data found",
      },
    },
  };

  const dashboardHistoryGridColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: false,
      },
    },
    {
      name: "CreatedDate",
      label: "Date",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD-MMM-YYYY");
        },
      },
    },
    {
      name: "UserName",
      label: "User",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    {
      name: "RoleName",
      label: "User Role",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    {
      name: "Action",
      label: "Action Performed",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    {
      name: "Remarks",
      label: "Remark/Comments",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: false,
      },
    },
    // {
    //   name: "attachments",
    //   label: "Attachments",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: false,
    //     customBodyRender: (value, tableMeta) => {
    //       // console.log("Attachments", tableMeta);
    //       let name = tableMeta.rowData[1];
    //       // debugger;
    //       if (value) {
    //         return <a href={value}>{name}</a>;
    //       } else {
    //         return <a href={value}></a>;
    //       }
    //     },
    //   },
    // },
  ];

  useEffect(() => {
    getHistoryData(props.id);
  }, [props.id]);

  const getHistoryData = async (id) => {
    setLoading(true);
    let requestParams = {
      id: id,
    };

    const res = await APICall(getKnowledgeHistoryById, requestParams);

    if (res.data !== null && res.data.length > 0) {
      setDashboardHistoryData(res.data);
    } else {
      setDashboardHistoryData([]);
    }
    setLoading(false);
  };

  return (
    <>
      <Loadspinner filename="ViewHistory.js" isLoading={loading} isMiddle="false" />
      <Modal.Body>
        <DynamicGrid
          options={dashboardHistoryOptions}
          data={dashboardHistoryData}
          columns={dashboardHistoryGridColumns}
        />
      </Modal.Body>
    </>
  );
};

export default ViewHistory;
